import { useSPIntl } from 'hooks/useIntl';
import { useCallback } from 'react';

type AmountOptions = { type: 'Amount'; currency: string; value?: number };
type PercentOptions = { type: 'Percent'; value?: number; alreadyMultiplied?: boolean };
export type PercentAmountOptions = AmountOptions | PercentOptions;

function isAmountOptions(opt: PercentAmountOptions): opt is AmountOptions {
  return opt.type === 'Amount';
}
function isPercentOptions(opt: PercentAmountOptions): opt is PercentOptions {
  return opt.type === 'Percent';
}

export function usePercentOrAmountFormatter(): (opt: PercentAmountOptions) => string {
  const { formatNumber } = useSPIntl();
  const formatter = useCallback(
    (opt?: PercentAmountOptions) => {
      if (opt?.type === undefined) {
        return '';
      }
      if (isPercentOptions(opt)) {
        {
          return `${formatNumber((opt.value ?? 0) * (opt.alreadyMultiplied === true ? 1 : 100), {
            maximumFractionDigits: 4,
          })}%`;
        }
      } else if (isAmountOptions(opt)) {
        return `${formatNumber(opt.value ?? 0, { maximumFractionDigits: 4 })} ${opt.currency}`;
      }
      return '';
    },
    [formatNumber],
  );
  return formatter;
}
